/**
 * @file ProductReviewsKpis.tsx
 * @description KPI-плашки очереди модерации отзывов (phase19.10):
 * на проверке / опубликовано / отклонено / средняя оценка.
 * Mobile — 2 колонки, desktop — 4.
 */

import { EditorialCard } from "../../../components/ui/EditorialCard";
import type { ReviewCounts } from "../../../lib/api-product-reviews";

interface ProductReviewsKpisProps {
  counts: ReviewCounts | null;
  /** Средняя по опубликованным; null — данных нет, показываем прочерк. */
  avgRating: number | null;
}

export function ProductReviewsKpis({ counts, avgRating }: ProductReviewsKpisProps) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      <Kpi label="На проверке" value={String(counts?.PENDING ?? 0)} />
      <Kpi label="Опубликовано" value={String(counts?.PUBLISHED ?? 0)} />
      <Kpi label="Отклонено" value={String(counts?.REJECTED ?? 0)} />
      <Kpi
        label="Средняя оценка"
        value={avgRating === null ? "—" : `${avgRating.toFixed(1)} ★`}
      />
    </div>
  );
}

function Kpi({ label, value }: { label: string; value: string }) {
  return (
    <EditorialCard>
      <EditorialCard.Body>
        <div className="text-xs uppercase tracking-wide text-on-surface-variant">
          {label}
        </div>
        <div className="mt-1 text-xl font-semibold">{value}</div>
      </EditorialCard.Body>
    </EditorialCard>
  );
}
